import { useEffect } from 'react';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import type { LoomEntryPointVariant } from './useLoomEntryPointVariantState.tsx';
import { useLoomEntryPointVariantState } from './useLoomEntryPointVariantState.tsx';

type UseLoomPermissionStatusOptions = {
	skip?: boolean;
};

/**
 * WARNING: This is meant to reflect Loom access status once M2.5 launches.
 *
 * For Beta, check `useIsLoomBetaEnabled` instead
 */
export const useLoomPermissionStatus = ({
	skip = false,
}: UseLoomPermissionStatusOptions = {}): LoomEntryPointVariant => {
	const { cloudId, userId } = useSessionData();
	const [{ loomEntryPointVariant }, { initLoomEntryPointVariant }] =
		useLoomEntryPointVariantState();
	const { entryPointVariant, loading } = loomEntryPointVariant;

	useEffect(() => {
		if (skip) {
			return;
		}

		if (entryPointVariant === 'NONE' && !loading) {
			initLoomEntryPointVariant(cloudId, userId);
		}
	}, [cloudId, initLoomEntryPointVariant, loading, entryPointVariant, skip, userId]);

	if (entryPointVariant === 'NONE') {
		return { entryPointVariant: 'NONE', loading: true };
	}

	return loomEntryPointVariant;
};
